import { Component, OnInit } from '@angular/core';
import { UiTable } from "../../../../../components/ui/table/table.component";
import { TableLigneBudgetaire } from '../../../../../data/schemas/table.schema';
import { LigneBudgetaireRequest } from '../../../../../data/http/requests/lignebudgetaire.req';
import { ModalComponent } from "../../../../../components/modal/modal.component";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LigneBudgetaireService } from '../../../../../services/lignebudgetaire/lignebudgetaire.service';
import { LigneBudgetaireResponse } from '../../../../../data/http/responses/lignebudgetaire.res';
import { Input } from "../../../../../components/forms/input/input";
import { AppService } from '../../../../../core/app.service';
import { LoaderComponent } from "../../../../../components/ui/loader/loader.component";
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';

@Component({
  selector: 'app-lignebudgetaire',
  standalone: true,
  imports: [
    UiTable,
    ModalComponent,
    ReactiveFormsModule,
    Input,
    LoaderComponent,
    UiButtonComponent,
    ConfirmDialogComponent,
    loaderIntervantion
  ],
  templateUrl: './lignebudgetaire.component.html',
  styleUrl: './lignebudgetaire.component.css'
})
export class LignebudgetairePage implements OnInit {

  public tableLigneBudgetaire = TableLigneBudgetaire;
  public showAddLigneBudgetaireModal: boolean = false;
  public ligneBudgetaires: LigneBudgetaireResponse[] = [];
  public isLoading: boolean = false;
  public isEditing: boolean = false;
  public editingLigneBudgetaire: LigneBudgetaireResponse | null = null;

  // Confirm dialog state
  public showDeleteConfirm: boolean = false;
  public selectedItem: LigneBudgetaireResponse | null = null;
  public deleteLoading: boolean = false;

  lignebudgetaireForm!: FormGroup;

  constructor(
    private ligneBudgetaireService: LigneBudgetaireService,
    private fb: FormBuilder,
    private appService: AppService
  ) {
    this.lignebudgetaireForm = this.fb.group({
      applicationId: this.appService.getAppId(),
      libelle: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.loadLigneBudgetaire();
  }

  saveLigneBudgetaire(): void {
    if (this.lignebudgetaireForm.valid) {
      this.isLoading = true;
      const requestBody: LigneBudgetaireRequest = this.lignebudgetaireForm.value;

      if (this.isEditing && this.editingLigneBudgetaire) {
        this.ligneBudgetaireService.update(this.editingLigneBudgetaire.id, requestBody).subscribe({
          next: () => {
            this.loadLigneBudgetaire();
            this.closeAddLigneBudgetaireModal();
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur lors de la mise à jour :', error);
            this.isLoading = false;
          }
        });
      } else {
        this.ligneBudgetaireService.create(requestBody).subscribe({
          next: () => {
            this.lignebudgetaireForm.reset({ applicationId: this.appService.getAppId(), libelle: '' });
            this.loadLigneBudgetaire();
            this.closeAddLigneBudgetaireModal();
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur lors de la création :', error);
            this.isLoading = false;
          }
        });
      }
    } else {
      this.lignebudgetaireForm.markAllAsTouched();
    }
  }

  loadLigneBudgetaire(): void {
    this.isLoading = true;
    this.ligneBudgetaireService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.ligneBudgetaires = response.data;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement :', error);
        this.isLoading = false;
      }
    });
  }

  openAddLigneBudgetaireModal(): void {
    this.isEditing = false;
    this.editingLigneBudgetaire = null;
    this.lignebudgetaireForm.reset({ applicationId: this.appService.getAppId(), libelle: '' });
    this.showAddLigneBudgetaireModal = true;
  }

  closeAddLigneBudgetaireModal(): void {
    this.showAddLigneBudgetaireModal = false;
    this.isEditing = false;
    this.editingLigneBudgetaire = null;
    this.lignebudgetaireForm.reset({ applicationId: this.appService.getAppId(), libelle: '' });
  }

  onEditTask(item: LigneBudgetaireResponse): void {
    this.isEditing = true;
    this.editingLigneBudgetaire = item;
    this.lignebudgetaireForm.patchValue({ libelle: item.libelle, applicationId: this.appService.getAppId() });
    this.showAddLigneBudgetaireModal = true;
  }

  // ── Confirm delete ──
  openDeleteConfirm(item: LigneBudgetaireResponse): void {
    this.selectedItem = item;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.selectedItem = null;
  }

  confirmDelete(): void {
    if (!this.selectedItem) return;
    this.deleteLoading = true;
    this.ligneBudgetaireService.delete(this.selectedItem.id).subscribe({
      next: () => {
        this.loadLigneBudgetaire();
        this.cancelDelete();
        this.deleteLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors de la suppression :', error);
        this.deleteLoading = false;
      }
    });
  }
}